import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[edtell-header]",
})
export class EdtellHeaderHelperDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
